export const enSubmitResetAdmin = {
  //text
  CA50submitResetAdmin: 'Send',
}
